import { render, staticRenderFns } from "./DropdownDefault.vue?vue&type=template&id=5dca4ac9&"
import script from "./DropdownDefault.vue?vue&type=script&lang=js&"
export * from "./DropdownDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports